// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2SWDD","colMaxWidth":"Table_colMaxWidth__1RuOS"};